import React from 'react';
import { ShoppingCart, PackageCheck } from 'lucide-react';
import { ProductCard, StatusTag, EmptyState, CollapsibleCard } from '../../../common';
import { getOutOfStockProducts } from './storeDetailAnalytics.controller';

function OutOfStock({ storeCheck }) {
    // Products unavailable in BOTH inventory AND store products
    const productsList = getOutOfStockProducts(storeCheck);

    return (
        <CollapsibleCard
            title="Quiebre de Stock"
            icon={<ShoppingCart />}
            iconTone="danger"
            badges={productsList.length > 0 && <StatusTag tone="danger">{productsList.length} productos</StatusTag>}>
            {productsList.length === 0 ? (
                <EmptyState icon={<PackageCheck />} title="Sin quiebres" description="No hay productos en quiebre de stock" />
            ) : (
                <div>
                    <p className="m-0 mb-4 text-xs text-surface-500">Productos no disponibles en piso de venta e inventario</p>
                    <div className="flex flex-row w-full flex-wrap gap-4">
                        {productsList?.map((product, i) => (
                            <ProductCard product={product} key={i} />
                        ))}
                    </div>
                </div>
            )}
        </CollapsibleCard>
    );
}

export default OutOfStock;
